/* eslint-disable complexity */
import { HYDRATE } from 'next-redux-wrapper';

import { IAvailableSeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import {
    ETicketPayment,
    EValidityStatus,
    TBonusesResult,
    TConnectionResult,
    TQrFetchingResult,
    TResetState,
    TSetBonusesAmount,
    TSetBonusesAmountValidity,
    TSetBonusesResult,
    TSetConnectionResult,
    TSetInProcess,
    TSetIsFetching,
    TSetIsUseBonuses,
    TSetPaymentSumIsError,
    TSetPaymentSumIsLoading,
    TSetQrCode,
    TSetQrFetchingResult,
    TSetQrLink,
    TSetSeasonTicket,
    TSetTicketPopup,
} from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { THydrateAction } from '~/src/store';

export type TConnectStep = 'success' | 'paid' | 'error' | 'declined' | 'qrError' | 'none';

export interface ITicketPopup {
    isOpen: boolean,
    step: TConnectStep,
    title: string,
    text?: React.ReactNode | string | null,
    type?: EResultPopupStatus,
}

export const initialTicketPopupState: ITicketPopup = {
    isOpen: false,
    step: 'none',
    title: '',
    text: '',
    type: EResultPopupStatus.DEFAULT,
};

export interface IBonusesPaymentState {
    isUseBonuses: boolean,
    amount: number,
    validity: EValidityStatus,
    result: TBonusesResult,
}

const initialBonusesInfo: IBonusesPaymentState = {
    isUseBonuses: false,
    amount: 0,
    validity: EValidityStatus.IS_VALID,
    result: 'none',
};

export interface ISbpState {
    isFetching: boolean,
    qrLink: string, // используется на мобилке
    qrCode: string, // используется на десктопе
    result: TQrFetchingResult,
}

export const initialSbpState: ISbpState = {
    isFetching: false,
    qrLink: '',
    qrCode: '',
    result: 'none',
};

export interface ISeasonTicketPaymentState {
    isInProcess: boolean,
    bonusesInfo: IBonusesPaymentState,
    sbpInfo: ISbpState,
    ticketPopup: ITicketPopup,
    result: TConnectionResult,
    paySumIsLoading: boolean,
    paySumIsError: boolean,
    seasonTicket?: IAvailableSeasonTicket,
}

export const initialState: ISeasonTicketPaymentState = {
    isInProcess: false,
    bonusesInfo: initialBonusesInfo,
    sbpInfo: initialSbpState,
    ticketPopup: initialTicketPopupState,
    paySumIsLoading: false,
    paySumIsError: false,
    result: 'none',
};

export type TSeasonTicketPaymentActions =
    | TResetState
    | TSetBonusesAmount
    | TSetBonusesAmountValidity
    | TSetBonusesResult
    | TSetConnectionResult
    | TSetInProcess
    | TSetIsFetching
    | TSetIsUseBonuses
    | TSetQrCode
    | TSetQrFetchingResult
    | TSetQrLink
    | TSetSeasonTicket
    | TSetTicketPopup
    | TSetPaymentSumIsLoading
    | TSetPaymentSumIsError

const seasonTicketPayment = (state = initialState, action: TSeasonTicketPaymentActions | THydrateAction): ISeasonTicketPaymentState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case ETicketPayment.SET_IN_PROCESS:
            return {
                ...state,
                isInProcess: action.payload,
            };
        case ETicketPayment.SET_SEASON_TICKET:
            return {
                ...state,
                seasonTicket: action.payload,
            };
        case ETicketPayment.SET_IS_USE_BONUSES:
            return {
                ...state,
                bonusesInfo: {
                    ...state.bonusesInfo,
                    isUseBonuses: action.payload,
                },
            };
        case ETicketPayment.SET_BONUSES_AMOUNT:
            return {
                ...state,
                bonusesInfo: {
                    ...state.bonusesInfo,
                    amount: action.payload,
                },
            };
        case ETicketPayment.SET_BONUSES_VALIDITY:
            return {
                ...state,
                bonusesInfo: {
                    ...state.bonusesInfo,
                    validity: action.payload,
                },
            };
        case ETicketPayment.SET_BONUSES_RESULT:
            return {
                ...state,
                bonusesInfo: {
                    ...state.bonusesInfo,
                    result: action.payload,
                },
            };
        case ETicketPayment.SET_CONNECTION_RESULT:
            return {
                ...state,
                result: action.payload,
            };
        case ETicketPayment.SET_IS_FETCHING:
            return {
                ...state,
                sbpInfo: {
                    ...state.sbpInfo,
                    isFetching: action.payload,
                },
            };
        case ETicketPayment.SET_PAYMENT_SUM_IS_LOADING:
            return {
                ...state,
                paySumIsLoading: action.payload,
            };
        case ETicketPayment.SET_PAYMENT_SUM_IS_ERROR:
            return {
                ...state,
                paySumIsError: action.payload,
            };
        case ETicketPayment.SET_QR_LINK:
            return {
                ...state,
                sbpInfo: {
                    ...state.sbpInfo,
                    qrLink: action.payload,
                },
            };
        case ETicketPayment.SET_QR_CODE:
            return {
                ...state,
                sbpInfo: {
                    ...state.sbpInfo,
                    qrCode: action.payload,
                },
            };
        case ETicketPayment.SET_QR_FETCHING_RESULT:
            return {
                ...state,
                sbpInfo: {
                    ...state.sbpInfo,
                    result: action.payload,
                },
            };
        case ETicketPayment.SET_TICKET_POPUP_STATE:
            return {
                ...state,
                ticketPopup: action.payload,
            };
        case ETicketPayment.RESET_STATE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default seasonTicketPayment;
